<template>
    <div class="flex items-center">
        <input type="text"
            v-model="text"
            class="w-full border border-gray-400 py-1 px-3 leading-normal outline-none"
            @focus="$event.target.select()">
        <button 
            aria-label="Copied!"
            :data-clipboard-text="text"
            class="tooltipped-no-delay px-3 py-1 bg-gray-400 border border-gray-400 border-l-0 hover:bg-gray-500 hover:text-white focus:outline-none flex-none"
            :class="tooltipClass"
            @mouseout="tooltipClass = null"
            ref="button">Copy</button>
    </div>
</template>
<script>
    import ClipboardJS from 'clipboard'
    export default {
        props: ['text'],
        data() {
            return {
                tooltipClass: null
            }
        },
        mounted() {
            let clipboard = new ClipboardJS(this.$refs.button);

            clipboard.on('success', (e) => {
                this.tooltipClass = 'tooltipped tooltipped-s'
            })
        }
    }
</script>